function addGoogleMarker(map, latitude, longitude, title, content, zoom, iconURL) {
    var id = title.split(';')[0];
    var name = title.split(';')[1];

    // Initialize point coordinates
    var point = new google.maps.LatLng(latitude, longitude);
    // Create Marker object
    var marker = new google.maps.Marker({
        map: map,
        position: point,
        title: name,
        icon: iconURL
    });

    // Register click event
    google.maps.event.addListener(marker, 'click', function () {
        var oZoom = map.getZoom();
        map.setCenter(point);

        if (oZoom !== zoom) {
            map.setZoom(zoom);
        }
    });

    var dealer = document.querySelector('.participating-dealer-list-item[data-id="' + id + '"]');

    if (dealer != null) {
        dealer.addEventListener('click', function () {
            var oZoom = map.getZoom();
            map.setCenter(point);

            if (oZoom !== zoom) {
                map.setZoom(zoom);
            }

        }, false);
    }
}

function setupAutocomplete() {

    // dynamically add places API b/c kentico controls the inclusion of
    // the maps API = we cannot use the libraries parameter.

    var TpsMapScriptInterval = setInterval(function () {

        if ($('script[src$="map.js"]').length > 0) {

            clearInterval(TpsMapScriptInterval);

            // dynamically get map.js src, and create places.js src
            // on the fly based on this file location
            var mapsApiUrl = $('script[src$="map.js"]').attr('src');
            console.log(mapsApiUrl);
            var placesSrc = (window.TpsPlacesApiUrl != '') ? window.TpsPlacesApiUrl : mapsApiUrl.replace('map.js', 'places.js');

            var placesScript = document.createElement('script');

            placesScript.setAttribute('src', placesSrc);
            document.body.appendChild(placesScript);

            applyPlacesApiToControl();
        }

    }, 100);



}

function applyPlacesApiToControl() {

    var input, AutoComplete;

    input = document.getElementById('txtDealerSearch');

    if (input) {

        let country = window.TpsAutocompleteCountry === 'en-US' ? 'us' : 'ca';

        var options = {
            componentRestrictions: { country: country }
        };
        // wait for places object to exist
        // then add autocomplete functionality
        var TpsPlacesInterval = setInterval(function () {
            if (google.maps.places) {
                clearInterval(TpsPlacesInterval);
                AutoComplete = new google.maps.places.Autocomplete(input, options);
            }
        }, 100);

    }
}

